export const getContentAreaMaxWidth = (columns: number): number => {
  const widthInPixels = (1240 / 12) * columns;
  //const widthInRem = pixelsToRem(widthInPixels);
  return widthInPixels;
};
